import React from "react"
import { Box } from "rebass"
import Img from "gatsby-image"
import { motion } from "framer-motion"
import { SizeMe } from "react-sizeme"

import Cloud from "./cloud"
import FloatingBox from "./floating-box"

const GreenCloud = () => (
  <Box
    css={{ position: "absolute", zIndex: 12 }}
    sx={{ bottom: [50], left: 100 }}
  >
    <motion.div
      animate={{ x: "calc(100vw - 50px)" }}
      transition={{ duration: 200, yoyo: Infinity }}
    >
      <Cloud color="#00FF1D" />
    </motion.div>
  </Box>
)

const BookPreview = ({ cover }) => (
  <SizeMe monitorHeight>
    {size => (
      <Box id="js-book-preview" p={4} css={{ position: "relative" }}>
        <FloatingBox
          width={size.size.width}
          height={size.size.height}
          initialPos={{ x: 0, y: 10 }}
        />
        <Box
          css={{ maxWidth: 500, boxShadow: "0 2px 24px 0 rgba(0, 0, 0, .4)" }}
          mx="auto"
        >
          <Img loading="eager" fluid={cover} />
        </Box>
        <GreenCloud />
      </Box>
    )}
  </SizeMe>
)

export default BookPreview
